export const PLAYER = {
  name: "Camden Clichee",
  firstName: "Camden",
  age: 12,
  position: "Point Guard",
  team: "Wookies",
  jersey: "10",
  shortBio:
    "Twelve years old. Pure shooter. Lock-down defender. Camden plays for the Wookies wearing #10 — and we're raising funds to send him to the NATTYS this June.",
  longBio:
    "Camden is twelve, hooping for the Wookies as their starting Point Guard. He's a knockdown shooter from anywhere on the court and brings energy on defense every single possession. This summer, his team has the chance to play on the biggest Indigenous youth basketball stage in the world — but only if we can cover the cost of getting him there.",
};

export const EVENT = {
  shortName: "The NATTYS",
  fullName: "7th Annual Native American Junior Nationals",
  hostedBy: "TRIBE Athletics Sports",
  dates: "June 25 – 28, 2026",
  city: "Mesa, AZ",
  venue: "Arizona Athletic Grounds",
  description:
    "The largest Indigenous basketball tournament in the world — 29 courts, a 4-game guarantee, and elite Native, Polynesian, Pacific Islander and Native Hawaiian youth teams from across the country competing in Mesa, Arizona.",
  tagline: "29 courts. 4 games guaranteed. One unforgettable summer.",
};

export const FUND = {
  goal: 5000,
  packages: [
    { id: "tip", amount: 10, label: "$10", subtitle: "Pre-game Gatorade" },
    { id: "starter", amount: 25, label: "$25", subtitle: "Tournament meal" },
    { id: "supporter", amount: 50, label: "$50", subtitle: "One night's per diem" },
    { id: "champion", amount: 100, label: "$100", subtitle: "Half a hotel night" },
    { id: "mvp", amount: 250, label: "$250", subtitle: "Tournament registration" },
    { id: "legend", amount: 500, label: "$500", subtitle: "Full travel package" },
  ],
  allocations: [
    { label: "Tournament Entry & Fees", pct: 30, color: "#00E5FF" },
    { label: "Travel to Mesa, AZ", pct: 25, color: "#FF007F" },
    { label: "Hotel (4 nights)", pct: 25, color: "#FACC15" },
    { label: "Gear, Food & Per Diem", pct: 20, color: "#A78BFA" },
  ],
};

export const MEDIA = {
  hero: "https://customer-assets.emergentagent.com/job_believe-and-give/artifacts/nfm3924b_IMG_9641.jpeg",
  gallery1: "https://customer-assets.emergentagent.com/job_believe-and-give/artifacts/wvy77x3g_IMG_9643.jpeg",
  gallery2: "https://customer-assets.emergentagent.com/job_believe-and-give/artifacts/gxq0420s_IMG_9642.jpeg",
};

export const BELIEVE = [
  {
    quote: "Represent the rez. Play for the ones who can't.",
    label: "Mindset 01",
  },
  {
    quote: "Heart over height. Effort over excuses.",
    label: "Mindset 02",
  },
  {
    quote: "Discipline beats talent when talent doesn't work.",
    label: "Mindset 03",
  },
  {
    quote: "Your situation doesn't decide your ceiling — you do.",
    label: "Mindset 04",
  },
  {
    quote: "Defense travels. Bring it every possession.",
    label: "Mindset 05",
  },
  {
    quote: "Believe loud. Work louder. Run it back.",
    label: "Mindset 06",
  },
];

// Match Challenge: when total raised crosses MATCH_TRIGGER, the next MATCH_POOL
// dollars are doubled by a Friend of the Family. Easy to edit.
export const MATCH = {
  trigger: 10,        // unlock threshold (USD)
  pool: 500,          // matching pool size (USD)
  sponsorName: "A Friend of the Family",
};
